//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.MoveBuilder.js";
import "../CAM/CAM.AxisMoveBuilder.js";
import "../CAM/CAM.AxisPreferredAngleBuilder.js";
let d=[[[0,"AAxis",1,1],[1,"AAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"AOutput",1,1],[0,"BAxis",1,1],[1,"BAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"BOutput",1,1],[0,"CAxis",1,1],[1,"CAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"COutput",1,1],[0,"FifthAxisRotaryDirection",1,0],[0,"FourthAxisRotaryDirection",1,0],[0,"MachineMoveAxis",1,0],[0,"PreferredAxisName",1,0],[1,"PreferredRangeMaximum",0,"CAM.AxisPreferredAngleBuilder",0],[1,"PreferredRangeMinimum",0,"CAM.AxisPreferredAngleBuilder",0],[0,"RotarySolution",1,0],[0,"ToolCenterPointControl",1,0],[0,"XAxis",1,1],[1,"XAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"XOutput",1,1],[0,"YAxis",1,1],[1,"YAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"YOutput",1,1],[0,"ZAxis",1,1],[1,"ZAxisMove",0,"CAM.AxisMoveBuilder",0],[0,"ZOutput",1,1]],[],[]];
SPLM.CAM.AlongMachineAxisMoveBuilder = class extends SPLM.CAM.MoveBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.AlongMachineAxisMoveBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.AlongMachineAxisMoveBuilder.ToolCenterPointControlType = Object.freeze({
    "MoveAxisOnly" : "MoveAxisOnly", "KeepTooltipPosition" : "KeepTooltipPosition"});

SPLM.CAM.AlongMachineAxisMoveBuilder.MachineMoveAxisType = Object.freeze({
    "MachineAxis" : "MachineAxis", "CoordinateAxis" : "CoordinateAxis"});

SPLM.CAM.AlongMachineAxisMoveBuilder.RotarySolutionType = Object.freeze({
    "Default" : "Default", "Alternative" : "Alternative"});

SPLM.CAM.AlongMachineAxisMoveBuilder.RotaryDirectionType = Object.freeze({
    "Standard" : "Standard", "Reverse" : "Reverse"});

export default SPLM;